export const parseAsset = asset => {
  let result = {
    id: asset.id,
    subtitle: asset.name,
    image: asset.thumbnailUrl,
    fileUrl: asset.fileUrl
  };

  return result;
};

export const parseOrg = org => {
  let result = {
    id: org.id,
    section: org.name,
    type: org.type,
    images: []
  };
  for (let i = 0; i < org.assets.length; i++) {
    let asset = parseAsset(org.assets[i]);
    result.images.push(asset);
  }

  return result;
};

export const parseResult = list => {
  let result = [];
  for (let i = 0; i < list.length; i++) {
    let org = parseOrg(list[i]);
    result.push(org);
  }
  return result;
};

export function createProportionalDimensions(width, height) {
  let required_width = 600;
  if (width < 600) {
    return required_width + "x" + height;
  } else {
    let required_height = Math.round((height * 600) / width);
    return required_width + "x" + required_height;
  }
}
